import * as React from 'react';
import { Routes, Route } from 'react-router-dom';

import { PermissionPage, Error404 } from 'ui-lib';

import { ReportsComponent } from './reports';
// import { OperationalReportComponent } from './operational';
import { DeploymentsReportComponent } from './deployments';
import { FirmwareVersionsReportComponent } from './firmware-versions';
import { useAuthStore, useRoutesStore, useStores } from '../../../../store';

import reportsCss from './reports.css';
import { SnapshotComparisonComponent } from './snapshot-comparison';
import { CommissionedHistoryReportComponent } from './commissioned-history';
import { AccountType } from 'dto/access-management/account-dto';

export enum REPORT_ROUTE_CODES {
    ROOT = 'ADMIN_REPORTS',
    // OPERATIONAL = 'ADMIN_REPORTS_OPERATIONAL',
    DEPLOYMENTS = 'ADMIN_REPORTS_DEPLOYMENTS',
    FIRMWARE_VERSIONS = 'ADMIN_REPORTS_FIRMWARE_VERSIONS',
    SNAPSHOT_COMPARISON = 'ADMIN_REPORTS_SNAPSHOT_COMPARISON',
    COMMISSIONED_HISTORY = 'ADMIN_REPORTS_COMMISSIONED_HISTORY',
}

export function ReportsModulePages() {
    const routeStore = useRoutesStore();
    const { permissionStore } = useStores();
    const {currentUser} = useAuthStore();
    const rootRoute = routeStore.getRoute(REPORT_ROUTE_CODES.ROOT);
    // const operationalRoute = routeStore.getRoute(REPORT_ROUTE_CODES.OPERATIONAL);
    const deploymentRoute = routeStore.getRoute(REPORT_ROUTE_CODES.DEPLOYMENTS);
    const firmwareVersionRoute = routeStore.getRoute(REPORT_ROUTE_CODES.FIRMWARE_VERSIONS);
    const snapshotComparisonRoute = routeStore.getRoute(REPORT_ROUTE_CODES.SNAPSHOT_COMPARISON);
    const commissionedHistoryRoute = routeStore.getRoute(REPORT_ROUTE_CODES.COMMISSIONED_HISTORY);

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <PermissionPage
                        permissionCodes={permissionStore.permissionCodes}
                        routes={routeStore.routes}
                        title={rootRoute.label}
                    >
                        <ReportsComponent />
                    </PermissionPage>
                }
            />
            {/* <Route
                path={operationalRoute.trimRootPath(rootRoute.path)}
                element={
                    <PermissionPage
                        permissionCodes={permissionStore.permissionCodes}
                        routes={routeStore.routes}
                        title={operationalRoute.label}
                        className={reportsCss.reports}
                    >
                        <OperationalReportComponent />
                    </PermissionPage>
                }
            /> */}
            <Route
                path={deploymentRoute.trimRootPath(rootRoute.path)}
                element={
                    <PermissionPage
                        permissionCodes={permissionStore.permissionCodes}
                        routes={routeStore.routes}
                        title={deploymentRoute.label}
                        className={reportsCss.reports}
                    >
                        <DeploymentsReportComponent />
                    </PermissionPage>
                }
            />
            <Route
                path={firmwareVersionRoute.trimRootPath(rootRoute.path)}
                element={
                    <PermissionPage
                        permissionCodes={permissionStore.permissionCodes}
                        routes={routeStore.routes}
                        title={firmwareVersionRoute.label}
                        className={reportsCss.reports}
                    >
                        <FirmwareVersionsReportComponent />
                    </PermissionPage>
                }
            />
            {currentUser.accountType === AccountType.DPU && (
                <Route
                    path={commissionedHistoryRoute.trimRootPath(rootRoute.path)}
                    element={
                        <PermissionPage
                            permissionCodes={permissionStore.permissionCodes}
                            routes={routeStore.routes}
                            title={commissionedHistoryRoute.label}
                            className={reportsCss.reports}
                        >
                            <CommissionedHistoryReportComponent />
                        </PermissionPage>
                    }   
                />
            )}
            <Route
                path={snapshotComparisonRoute.trimRootPath(rootRoute.path)}
                element={
                    <PermissionPage
                        permissionCodes={permissionStore.permissionCodes}
                        routes={routeStore.routes}
                        title={snapshotComparisonRoute.label}
                        className={reportsCss.reports}
                    >
                        <SnapshotComparisonComponent />
                    </PermissionPage>
                }
            />
            <Route path='*' element={<Error404 message='Page Not Found' />} />
        </Routes>
    );
}
